import React, { useEffect, useState } from 'react';
import IframeComponent from '../../components/IframeComponent';
import LoadingPage from '../../components/LoadingPage';
import LinkExpired from '../../components/LinkExpired';
import { withLinkValidation } from '../../hoc/withLinkValidation';

const ChatbotIframeProd = ({ params }) => {
    const [paymentUrl, setPaymentUrl] = useState('');
    const [isPaymentAllowed, setIsPaymentAllowed] = useState(true);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        let environment = "chat_prod";

        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('/qa/')) {
            environment = "qa"
        }

        // Get parameters from props (passed by HOC)
        const objectID = params.get('objectID');
        const streamID = params.get('streamID');
        const customerID = params.get('customerID');
        const contractID = params.get('contractID');
        let amount = (params.get('amount') * 100).toString();
        
        const userDataArray = [
            { key: 'objectID', value: objectID },
            { key: 'customerID', value: customerID },
            { key: 'contractID', value: contractID },
            { key: 'streamID', value: streamID },
        ];

        // Constructing userData XML elements
        let userDataXml = userDataArray
            .map((data, index) => `<userData${index + 1}>${data.value}</userData${index + 1}>`)
            .join('');

        userDataXml += `<userData9>${environment}</userData9>`;
        userDataXml += `<userData10>chatbot</userData10>`;

        const checkTime = async (streamID, objectID) => {
            try {
              const response = await fetch(`${backendUrl}/api/qa/check-time`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ streamID, objectID })
              });
      
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
      
              const data = await response.json();
              console.log('checkTime data:', data);
              // אני מניח שה-Backend מחזיר { isPaymentAllowed: true/false }
              return data.isPaymentAllowed;
            } catch (error) {
              console.error('Something happened in checkTime:', error);
              return false;
            }
        };

        const fetchPayment = async () => {
            try {
                const response = await fetch(`${backendUrl}/api/process-payment-chatbot-prod`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json'},
                    body: JSON.stringify({ 
                        amount: amount,
                        customerId: customerID,
                        env: environment,
                        userData: userDataXml
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setPaymentUrl(data.url);
            } catch (error) {
                console.log("Something happened: ", error);
            }
        };

        // Execute original chatbot production logic
        (async () => {
            // קודם בודקים אם תשלום מותר (דרך השרת שלנו)
            const allowed = await checkTime(streamID, objectID);
            setIsPaymentAllowed(allowed);
      
            // אם מותר, מפעילים את פונקציית התשלום
            if (allowed) {
              fetchPayment();
            }
        })();

    }, [params, backendUrl]);

    return (
        <>
           {isPaymentAllowed ? (
                    paymentUrl ? (
                        <IframeComponent src={paymentUrl}/>
                    ) : (
                        <LoadingPage/>
                    )
                ) : (
                    <LinkExpired />
            )}
        </>
    );
};

export default withLinkValidation(ChatbotIframeProd);
